import * as React from "react";
import { SysParentsColumn } from "src/business/sysData/SysParentsColumn";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";
import { ZSidLabel } from "src/types";

import { ZAttrMeta } from "../attribute";
import { AttrView } from "../attribute/attrViews";
import { filterViewableAttrs } from "../attribute/filterViewableAttrs";
import { ZSpecification } from "../specification";
import { columnDisplayId, sysColumnsHistory } from "../sysData/sysColumns";
import { ZClassRow } from "./ZClassRow";

type AttrSpec = ZAttrMeta & {
  specName: string;
};

const makeColumn = (attr: AttrSpec): RtColumn<ZClassRow> => ({
  key: `${attr.specName}.${attr.name}`,
  title: attr.view?.title ?? attr.title,
  width: attr.view?.width ?? undefined,
  minWidth: attr.view?.minWidth ?? undefined,
  render: ({ data }) => {
    const value = data?.[attr.specName]?.[attr.name];
    return value ? <AttrView value={value} meta={attr} /> : null;
  },
});

export const buildClassColumns = (
  schemes: ZSpecification[],
  displayAttribute: ZSidLabel | null | undefined,
): RtColumn<ZClassRow>[] => {
  let result: RtColumn<ZClassRow>[] = [...columnsBegin];

  const attrs: AttrSpec[] = schemes.flatMap(({ name: specName, definition }) =>
    filterViewableAttrs(definition?.attributes ?? []).map((attr) => ({
      ...attr,
      specName,
    })),
  );
  const nameAttr: AttrSpec | undefined = displayAttribute
    ? attrs.find(({ uid }) => uid === displayAttribute.id)
    : undefined;

  if (nameAttr) {
    result.splice(1, 0, makeColumn(nameAttr));
    result = [
      ...result,
      ...attrs.filter(({ uid }) => uid !== nameAttr.uid).map(makeColumn),
    ];
  } else {
    result = [...result, ...attrs.map(makeColumn)];
  }
  return [...result, ...sysColumnsHistory];
};

const columnsBegin: RtColumn<ZClassRow>[] = [
  columnDisplayId,
  {
    key: "parent",
    title: "Родитель",
    minWidth: 150,
    width: 200,
    render: (row) => <SysParentsColumn parents={row.parents} />,
  },
];
